import React from "react";
import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

export const ValidationException = styled.div`
  color: ${colors.redD};
`;

interface ValidationExceptionProps {
  message: string;
}

export const DangerousValidationException = ({
  message,
}: ValidationExceptionProps) => {
  return (
    <ValidationException
      dangerouslySetInnerHTML={{
        __html: message
          .replace("GraphQL error: ", "")
          .replace("[TOM TASK][CREATE] ", ""),
      }}
    />
  );
};
